import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	invalidPriority: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.priorities.invalid-priority',
		defaultMessage:
			'This priority no longer exists. Check your Jira priorities or remove this time target.',
		description:
			'message for error icon tooltip when the priorirty that is used in an SLA Subgoal gets modified',
	},
	selectPriority: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.priorities.select-priority',
		defaultMessage: 'Select priority',
		description: 'Aria label for Priority combobox',
	},
});
